import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RecruitingState } from 'src/app/recruiting/store/recruiting.state';
import { TeamInfo } from '../candidates/new-profile/team-info/models/team-info.model';

export const RecruitingFeatureKey = 'recruiting';

export const selectFeature = createFeatureSelector<RecruitingState>(RecruitingFeatureKey);

export const selectCandidateTeamInfo = createSelector(
    selectFeature,
    (state: RecruitingState): TeamInfo => state.recruitingState.teamInfo
);
